import {
  Component,
  ElementRef,
  OnInit,
  AfterViewInit,
  inject,
  viewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Link } from '@coworkrz/shared/admin-layout';
import { RouterModule } from '@angular/router';
import { NgIconComponent, provideIcons } from '@ng-icons/core';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import {
  hugeOfficeChair,
  hugeCoffee02,
  hugeInformationCircle,
  hugeLogout01,
  hugeShoppingBasket03,
} from '@ng-icons/huge-icons';
import { saxProfile2userOutline } from '@ng-icons/iconsax/outline';
import { AuthService } from '@coworkrz/auth/data-access';
import { LOCATION_TOKEN } from '@coworkrz/shared/misc';
import {
  MenuComponent,
  MenuTriggerForDirective,
  BadgeComponent,
} from '@coworkrz/shared/ui';
import { User } from '@coworkrz/users/types';
import { Dialog, DialogModule } from '@angular/cdk/dialog';
import { CartService, Cart } from '@coworkrz/carts/data-access';
import { RefreshmentCartComponent } from '@coworkrz/refreshments/feature-cart';

@Component({
  selector: 'app-portal-navbar',
  imports: [
    CommonModule,
    RouterModule,
    NgIconComponent,
    MenuComponent,
    MenuTriggerForDirective,
    DialogModule,
    BadgeComponent,
  ],
  providers: [
    provideIcons({
      hugeOfficeChair,
      hugeCoffee02,
      saxProfile2userOutline,
      hugeInformationCircle,
      hugeLogout01,
      hugeShoppingBasket03,
    }),
  ],
  templateUrl: './portal-navbar.component.html',
})
export class PortalNavbarComponent implements OnInit, AfterViewInit {
  breakpointObserver = inject(BreakpointObserver);
  private auth = inject(AuthService);
  dialog = inject(Dialog);
  private cartService = inject(CartService);
  private location = inject<Location>(LOCATION_TOKEN);

  readonly navBarTrigger = viewChild<ElementRef<HTMLElement>>('navBarTrigger');

  navBar = false;
  user: User;
  cart: Cart = { cartItems: [], totalAmount: 0, totalItems: 0 };
  isCartEmpty = true;

  links: Link[] = [
    {
      label: 'Coworking spaces',
      link: 'spaces',
      icon: 'hugeOfficeChair',
    },
    {
      label: 'Refreshments',
      link: 'refreshments',
      icon: 'hugeCoffee02',
    },
    {
      label: 'Account',
      link: 'account/profile',
      icon: 'saxProfile2userOutline',
    },
    {
      label: 'About',
      link: 'about',
      icon: 'hugeInformationCircle',
    },
  ];

  constructor() {
    this.cartService.cart$.subscribe((cart) => {
      this.cart = cart;
      this.isCartEmpty = cart.totalItems === 0;
    });
  }

  ngOnInit() {
    this.breakpointObserver
      .observe(['(max-width: 1199px)'])
      .subscribe((state: BreakpointState) => {
        if (!state.matches) {
          this.navBar = false;
        }
      });
    this.getUser();
  }

  ngAfterViewInit() {
    this.navBarTrigger()?.nativeElement.addEventListener(
      'click',
      this.hideNavbar.bind(this)
    );
  }

  private getUser(): void {
    this.auth.loadUser().subscribe((data) => {
      this.user = data;
    });
  }

  showNavbar() {
    this.navBar = !this.navBar;
  }

  hideNavbar() {
    this.navBar = false;
  }

  signOut(): void {
    this.auth.signOut();
    this.location.assign('/');
  }
  displayCart() {
    this.dialog.open<string | undefined>(RefreshmentCartComponent, {
      minWidth: '300px',
    });
  }
}
